import { axiosInstance } from "api";
import { useMutation, useQueryClient } from "react-query";
import { Container1, Container2, WrapBox1, Wrapper } from "./style";
import { useRef } from "react";
import { useScrollFadeIn } from "hooks/useScrollFadeIn";
const Com3 = ({ techLinkData }) => {
  const queryClient = useQueryClient();
  const { mutate } = useMutation((data) => axiosInstance.put("/link", data));
  const openHandler = (url, id) => {
    window.open(url);
    mutate(
      { id },
      {
        onSuccess: () => queryClient.invalidateQueries("techLink"),
        onError: (err) => console.log(err),
      },
    );
  };
  const ref = useRef();
  useScrollFadeIn(ref);
  return (
    <Wrapper ref={ref} className="fade-in">
      <Container1>
        <div>Tech & Discussion</div>
        <div>Showing {techLinkData.length} Tech & Discussion list</div>
      </Container1>
      <Container2>
        {techLinkData.map((v) => (
          <WrapBox1 key={v.title} onClick={() => openHandler(v.url, v.id)}>
            <img loading="lazy" src={v.icon_path} alt="tech_Image" />
            <div>
              <span>{v.title}</span>
            </div>
          </WrapBox1>
        ))}
      </Container2>
    </Wrapper>
  );
};

export default Com3;
